if (process.env.NODE_ENV === 'production') {
  window.debug = () => {}
  console.log = () => {}
  console.warn = () => {}
  console.error = () => {}
  console.info = () => {}
  console.debug = () => {}
}

import Vue from 'vue'
import '@/components/global'
// wip: convert filters into helpers / plugins & never use filters
import '@/utils/Filters'
import '@/plugins'

import App from './App.vue'
import i18n from '@/plugins/i18n'
import router from './router'
import store from './store'
import { mqInstance } from '@/plugins/media-query'
import { ANALYTICS_EVENT, logEvent } from '@/utils/analytics.js'
// import * as Sentry from '@sentry/vue'
// import { Integrations } from '@sentry/tracing'
// wip: use mitt for events
export const eventBus = new Vue()

// Track page views after each navigation
router.afterEach((to) => {
  logEvent(ANALYTICS_EVENT.NAVIGATION.OTO_ADMIN_PAGE_VIEW, {
    page_name: to.name,
    page_path: to.fullPath,
  })
})

Vue.config.productionTip = false

// Sentry.init({
//   Vue,
//   dsn: `${process.env.VUE_APP_SENTRY_DSN}`,
//   integrations: (integrations) => [
//     ...integrations,
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: [
//         'localhost',
//         /^\//,
//         /^https:\/\/.*\.otoride\.co/,
//         'https://admin.skootel.com/',
//         'https://oto-dev-admin.vercel.app/',
//       ],
//     }),
//   ],
//   tracesSampleRate: 1.0,
//   sendDefaultPii: true,
// })

new Vue({
  router,
  store,
  i18n,
  mediaQueries: mqInstance,
  render: (h) => h(App),
}).$mount('#app')

if (process.env.NODE_ENV === 'development') {
  window.__STORE__ = store
}
// let magnusAiScript = document.createElement('script')
// magnusAiScript.setAttribute(
//   'src',
//   `${process.env.VUE_APP_MAGNUSAI_API_URL}/api/v1/chat_widget/script/chat.js/${process.env.VUE_APP_MAGNUSAI_BRAIN_ID}/`
// )
// magnusAiScript.setAttribute('defer', '')

// document.body.appendChild(magnusAiScript)
